// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"569":"snake","769":"world"}[chunkId] || chunkId) + "." + {"408":"a76d0e8d","569":"51224980","769":"9fc51b62"}[chunkId] + ".chunk.js";
};